import React from 'react'
import { useLocation, useParams } from 'react-router-dom'
import axios from "axios";
import Moment from 'react-moment';

import ReactLoading from 'react-loading';
import config from "../../config"
import Barcode from 'react-barcode';
import { toWords } from 'number-to-words';

const Print_invoice = () => {
    const location = useLocation()
    const {shipment_id} = useParams()
    console.log("shipment_id",shipment_id)
    const searchParams = new URLSearchParams(window.location.search);
    const shipParam = searchParams.get('value');
    console.log("shipParam  === " ,shipParam )
  

    const[state,setState]= React.useState({shipment_list:[]})
    console.log("state",state)
    const[dimensionState,setdimensionState] = React.useState({companyDetail:[]})


    React.useEffect(() => {
      dimension_detail()
      shipment_detail()
    
      }, [])

    const shipment_detail=()=>{
        let dataToSend = {shipment_id:shipment_id };
   
      console.log("datatoSend",dataToSend)
      
      let full_api = config.apiUrl + '/shipment/shipment_detail';
      axios.post(full_api, dataToSend, { headers: config.headers })
          .then((res) => {
            console.log("responseJson => ", res);
            setState({shipment_list:res.data.output})
          
  
         
          })
          .catch((error) => {
              //Hide Loader
            //   setLoadingstate({...loadingstate,loading:false})
              console.log(error);
          });    

    }
    const dimension_detail = () =>{

      let full_api = config.apiUrl + `/shipment/company_info_api`;
      let sendData = {};
      axios.post(full_api, sendData, { headers: config.headers }).then(res => {
        setdimensionState({...dimensionState,companyDetail:res.data.companyDetail});
        console.log("rnmmmmm", res);
      }).catch((e) => {
        console.log("----error:   ", e);
      })
    }


return (
  <div>
{shipParam==1?
<div style={{fontSize: "12px",
        margin: "0",
        padding: "3mm",
        background: "rgba(235,235,235,1)",
        backgroundColor: "rgba(235,235,235,1)",
        fontFamily: "arial,sans-serif",
        lineHeight: "18px" , 
       }}>
          {state.shipment_list.map((sub)=>(
<div class="container mt-3 wrap" style={{ width:"75%"}}>
<div class="card mb-1">
    <div class="card-body">
      <div class="text-center MB-3">
        <h3>TAX INVOICE</h3>
      </div>
      <div class="text-end">
        <h4>Invoice</h4>
        <p>Invoice Number - {sub.order_number}<br/>Invoice Date - <Moment format="MMM DD YYYY">
                        {new Date(sub.created*1000)}
             </Moment></p>
      </div>
      <hr/>
      <table class="table">
          <tbody>
            <tr>
              <td style={{width: "40%"}}>
                <div class="mb-3">
                <h4>Bill To:</h4>
                <p>  <strong>{sub.receiver.name}</strong><br/>
                     {sub.receiver.address}, {sub.receiver.city}, {sub.receiver.state} {sub.receiver.pincode}
                 </p>
                
                </div>
                <div class="mb-3">
                  <h4>Ship To:</h4>
                  <p>
                  <strong>{sub.receiver.name}</strong><br/>
                     {sub.receiver.address}, {sub.receiver.city}, {sub.receiver.state} {sub.receiver.pincode}
                  </p>
                </div>
              </td>
              <td>&nbsp;</td>
              <td style={{width: "40%"}} class="text-end">
                <h4>Sold By:</h4>
                <p>
                <strong>{sub.sender.name}</strong><br/>
                {sub.sender.address}, {sub.sender.city}, {sub.sender.state} {sub.sender.pincode}
                </p>
              </td>
            </tr>
          </tbody>
        </table>

        <table class="table">
            <tbody>
              <tr>
                <td>
                  <div>
                    <strong>Payment Method:</strong>
                    {sub.payment_mode=="cod"?"Cod":"Prepaid"}
                  </div>
                  <div>
                    <strong>AWB No:</strong>
                    {sub.carrier_tracking_number?sub.carrier_tracking_number:""}
                  </div>
                </td>
                <td></td>
                <td class="text-end">
                  <div>
                    <strong>Order Date:</strong>
                    <Moment format="MMM DD YYYY">
                        {new Date(sub.created*1000)}
             </Moment>
                  </div>
                  <div>
                    <strong>Shipped By:</strong>
                    {sub.service_provider?sub.service_provider:sub.carrier_name}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
    </div>
</div> 

<div class="card mb-1">
  <div class="card-body">
    <div class="table-responsive">
        <table class="table table-striped">
            <thead class="">
              <tr>
                <th>Product Name</th>
                <th>Product SKU</th>
                <th>HSN</th>
                <th>QTY</th>
                <th>Unit Price</th>
                <th>Tax Amount</th>
                <th>GST (value)</th>
                <th>Total (Including GST)</th>
              </tr>
            </thead>
            <tbody>
              {sub.items.map((item)=>(
                <tr>
                  <td>{item.item_name}</td>
                  <td>-</td>
                  <td>-</td>
                  <td>{item.quantity}</td>
                  <td>{item.item_value}</td>
                  <td>-</td>
                  <td>-</td>
                  <td>Rs. {item.item_value}</td>
                </tr>
                ))}
            </tbody>
        </table>
    </div>
  </div>
</div>
<div class="card mb-1">
    <div class="card-body">
      <div class="row justify-content-end">
          <div class="col-8">
            <div class="table-responsive">
                <table class="table table-striped">
                    <thead>
                      <tr>
                        <th>Charges Applied</th>
                        <th>Tax Amount</th>
                        <th>IGST Value(%)</th>
                        <th>Total (Including GST)</th>
                      </tr>
                    </thead>
                    <tbody>
                        <tr>
                          <td>Shipping Charges</td>
                          <td>-</td>
                          <td>-</td>
                          <td>-</td>
                        </tr>
                        <tr>
                          <td>COD Charges</td>
                          <td>-</td>
                          <td>-</td>
                          <td>-</td>
                        </tr>
                      <tr>
                        <td></td>
                        <td></td>
                        <td class="fw-bold">Amount Due</td>
                        <td>Rs. {sub.items.reduce((total, sub) => total + parseFloat(sub.item_value), 0).toFixed(2)}</td>
                      </tr>
                    </tbody>
                </table>
            </div>
          </div>
      </div>
    </div>
</div>
<div className=''>This is a computer-generated invoice ,  no signature is required.</div> 
</div>

          ))}
       
</div>
:
state.shipment_list.map((sub)=>(
<div class="container mt-4">
        <div class="text-center">
            <strong>Invoice</strong>
        </div>
        <div class="label-box">
            <table className='int-table'>
                <tr className='int-tr'>
                    <td className='int-td'>
                       <h6 className='int-h6' >Exporter:</h6>
                        {sub.sender.name} <br/>
                        {sub.sender.address}, 
                        {sub.sender.city},{sub.sender.state}, {sub.sender.country} {sub.sender.pincode}<br/>
                        Phone: {sub.sender.mobile} 
                    </td>
                    <td className='int-td'>
                        <table class="table_borderless int-table">
                            <tr className='int-tr'>
                                <td style={{minWidth: "120px"}} className='int-td'>
                                    <h6 className='int-h6'>Invoice No.</h6>
                                    {sub.order_number} 
                                </td>
                                <td style={{minWidth: "120px"}} className='int-td'>
                                    <h6 className='int-h6'>Date</h6>
                                    <Moment format="MMM DD YYYY">
                        {new Date(sub.created*1000)}
             </Moment>
                                </td>
                                <td style={{minWidth: "140px"}} className='int-td'>
                                    <h6 className='int-h6'>Exporter's Ref.:</h6>
                                </td>
                            </tr>
                            <tr className='int-tr'>
                                <td className='int-td' colspan="3">
                                    <span class="int-bold">Aadhaar number</span>: {sub.shipper_kyc_number_1!=""?sub.shipper_kyc_number_1:sub.shipper_kyc_number_2}
                                </td>
                            </tr>
                            <tr className='int-tr'>
                                <td className='int-td' colspan="2">
                                    &nbsp;
                                </td>
                                <td className='int-td'>
                                    &nbsp;
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
                <tr className='int-tr'>
                    <td className='int-td'>
                        <h6 className='int-h6'>Consignee:</h6>
                        {sub.receiver.name} <br/>
                        {sub.receiver.address},  {sub.receiver.city}  {sub.receiver.pincode},  {sub.receiver.country}<br/>
                        Phone:  {sub.receiver.mobile} 
                    </td>
                    <td className='int-td'>
                        <table class="table_borderless int-table" >
                            <tr className='int-tr'>
                                <td className='int-td' colspan="2">&nbsp;</td>
                            </tr>
                            <tr className='int-tr'>
                                <td className='int-td'>&nbsp;</td>
                                <td className='int-td'>&nbsp;</td>
                            </tr>
                            <tr className='int-tr'>
                                <td className='int-td'>
                                    <h6 className='int-h6'>Country of Origin</h6>
                                    INDIA
                                </td>
                                <td className='int-td'>
                                    <h6 className='int-h6'>Country of final Destination</h6>
                                    {sub.receiver.country}
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
                <tr className='int-tr'>
                    <td className='int-td'>
                        <table class="table_borderless int-table">
                            <tr className='int-tr'>
                                <td className='int-td'>
                                    <h6 className='int-h6'>Pri-Carriage by</h6>
                                    Courier
                                </td>
                                <td className='int-td'>
                                    <h6 className='int-h6'>Place of Receipt by Pre-Carrier</h6>
                                    KANNUR
                                </td>
                            </tr>
                            <tr className='int-tr'>
                                <td className='int-td'>
                                    <h6 className='int-h6'>Vessel/Flight No</h6>
                                    &nbsp;
                                </td>
                                <td className='int-td'>
                                    <h6 className='int-h6'>Port of Loading</h6>
                                    &nbsp;
                                </td>
                            </tr>
                            <tr className='int-tr'>
                                <td className='int-td'>
                                    <h6 className='int-h6'>Port of Discharge</h6>
                                    &nbsp;
                                </td>
                                <td className='int-td'>
                                    <h6 className='int-h6'>Final Destination</h6>
                                    {sub.receiver.country}
                                </td>
                            </tr>
                        </table>
                    </td>
                    <td className='int-td'>
                        <h6 className='int-h6'>Terms of Delivery and Payment</h6>
                        &nbsp;
                    </td>
                </tr>
                <tr className='int-tr'>
                    <td className='int-td' colspan="2">
                        <table  class="table_borderless int-table">
                            <tr className='int-tr'>
                                <td className='int-td'><h6 className='int-h6'>SrNo </h6></td>
                                <td className='int-td'><h6 className='int-h6'>PCS AwbNo</h6></td>
                                <td className='int-td'><h6 className='int-h6'>Description of Goods</h6></td>
                                <td className='int-td'><h6 className='int-h6'>HSN</h6></td>
                                <td className='int-td'><h6 className='int-h6'>Quantity
                                    (IN PCS)</h6></td>
                                <td className='int-td'><h6 className='int-h6'>Rate (INR)</h6></td>
                                <td className='int-td'><h6 className='int-h6'>Amount C&F INR</h6></td>
                            </tr>
                           
                 {sub.invoice_items.map((item , index)=>(
                            <tr className='int-tr'>
                                <td class="border_b_0 int-td">{index+1}</td>
                                <td class="border_b_0 int-td">{sub.carrier_tracking_number} </td>
                                <td class="border_b_0 int-td">{item.description}</td>
                                <td class="border_b_0 int-td">-</td>
                                <td class="border_b_0 int-td">{item.quantity}</td>
                                <td class="border_b_0 int-td">{item.amount}</td>
                                <td class="border_b_0 int-td">{item.amount}</td>
                            </tr>
                 ))}
                            <tr className='int-tr'>
                                <td class="border_t_0 border_b_0 int-td">&nbsp;</td>
                                <td class="border_t_0 border_b_0 int-td">&nbsp;</td>
                                <td class="border_t_0 border_b_0 int-td">&nbsp;</td>
                                <td class="border_t_0 border_b_0 int-td">&nbsp;</td>
                                <td class="border_t_0 border_b_0 int-td">&nbsp;</td>
                                <td class="border_t_0 border_b_0 int-td">&nbsp;</td>
                                <td class="border_t_0 border_b_0 int-td">&nbsp;</td>
                            </tr>
                            <tr className='int-tr'>
                                <td class="border_t_0 border_b_0 int-td">&nbsp;</td>
                                <td class="border_t_0 border_b_0 int-td">&nbsp;</td>
                                <td class="border_t_0 border_b_0 int-td">&nbsp;</td>
                                <td class="border_t_0 border_b_0 int-td">&nbsp;</td>
                                <td class="border_t_0 border_b_0 int-td">&nbsp;</td>
                                <td class="border_t_0 border_b_0 int-td">&nbsp;</td>
                                <td class="border_t_0 border_b_0 int-td">&nbsp;</td>
                            </tr>
                            <tr className='int-tr'>
                                <td class="border_t_0 border_b_0 int-td">&nbsp;</td>
                                <td class="border_t_0 border_b_0 int-td">&nbsp;</td>
                                <td class="border_t_0 border_b_0 int-td">&nbsp;</td>
                                <td class="border_t_0 border_b_0 int-td">&nbsp;</td>
                                <td class="border_t_0 border_b_0 int-td">&nbsp;</td>
                                <td class="border_t_0 border_b_0 int-td">&nbsp;</td>
                                <td class="border_t_0 border_b_0 int-td">&nbsp;</td>
                            </tr>
                            <tr className='int-tr'>
                                <td class="border_t_0 border_b_0 int-td">&nbsp;</td>
                                <td class="border_t_0 border_b_0 int-td">&nbsp;</td>
                                <td class="border_t_0 border_b_0 int-td">&nbsp;</td>
                                <td class="border_t_0 border_b_0 int-td">&nbsp;</td>
                                <td class="border_t_0 border_b_0 int-td">&nbsp;</td>
                                <td class="border_t_0 border_b_0 int-td">&nbsp;</td>
                                <td class="border_t_0 border_b_0 int-td">&nbsp;</td>
                            </tr>
                           <tr className='int-tr'>
                                <td class="border_t_0 border_b_0 int-td">&nbsp;</td>
                                <td class="border_t_0 border_b_0 int-td">&nbsp;</td>
                                <td class="border_t_0 border_b_0 int-td">&nbsp;</td>
                                <td class="border_t_0 border_b_0 int-td">&nbsp;</td>
                                <td class="border_t_0 border_b_0 int-td">&nbsp;</td>
                                <td class="border_t_0 border_b_0 int-td">&nbsp;</td>
                                <td class="border_t_0 border_b_0 int-td">&nbsp;</td>
                            </tr>
                            <tr className='int-tr'>
                                <td class="border_t_0 border_b_0 int-td">&nbsp;</td>
                                <td class="border_t_0 border_b_0 int-td">&nbsp;</td>
                                <td class="border_t_0 border_b_0 int-td">&nbsp;</td>
                                <td class="border_t_0 border_b_0 int-td">&nbsp;</td>
                                <td class="border_t_0 border_b_0 int-td">&nbsp;</td>
                                <td class="border_t_0 border_b_0 int-td">&nbsp;</td>
                                <td class="border_t_0 border_b_0 int-td">&nbsp;</td>
                            </tr>
                            <tr className='int-tr'>
                                <td class="border_t_0  int-td">&nbsp;</td>
                                <td class="border_t_0  int-td">&nbsp;</td>
                                <td class="border_t_0  int-td">&nbsp;</td>
                                <td class="border_t_0  int-td">&nbsp;</td>
                                <td class="border_t_0  int-td">&nbsp;</td>
                                <td class="border_t_0  int-td">&nbsp;</td>
                                <td class="border_t_0  int-td">&nbsp;</td>
                            </tr>
                            <tr className='int-tr'>
                                <td class="border_t_0 int-td" colspan="5">
                                    Amount Chargeable <br/>
                                    TOTAL INR {toWords(sub.invoice_items.reduce((total, sub) => total + parseFloat(sub.amount), 0))} Rupees Only
                                </td>
                                <td class="border_t_0 text-end int-td" colspan="">
                                    <h6 className='int-h6'>Total</h6>
                                </td>
                                <td class="border_t_0 int-td">{sub.invoice_items.reduce((total, sub) => total + parseFloat(sub.amount), 0).toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td class="border_t_0 int-td" colspan="3">
                                    <h6 className='int-h6'>Declaration :</h6>
                                    We declare that this Invoice show the actual price of the goods
described and that all particulars are true and correct
                                </td>
                                <td class="border_t_0 int-td" colspan="4">
                                    For {sub.sender.name} <br/> <br/>
                                    Signature & Date
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
            </table>
        </div>
    </div>
))
}
</div>
  )
}

export default Print_invoice



 